module.exports = __webpack_public_path__ + "static/media/brands-02-kfc@2x.0c74aeb3.png";